import api from './api';

const CANVA_PROVIDERS = ['canva', 'custom_canva', 'custom_canva2'];

export const findCanvaAccount = (user) =>
  user?.externalAccounts?.find((account) => CANVA_PROVIDERS.includes(account.provider));

/**
 * Remove the user's Canva external account from Clerk.
 *
 * With `markDisconnected`, a removed link is also reported to the backend
 * (fire-and-forget) so the crons stop sweeping the user. The connect flow's
 * destroy-before-create leaves it off: a new link follows immediately and
 * Fetch Folders marks it connected once Canva accepts the token.
 *
 * @returns {Promise<boolean>} whether an account was removed
 */
export const unlinkCanva = async (user, { markDisconnected = false } = {}) => {
  const account = findCanvaAccount(user);
  if (!account) return false;
  await account.destroy();
  if (markDisconnected) void api.markCanvaDisconnected();
  return true;
};
